import { render, staticRenderFns } from "./TwoPhaseMailVerify.vue?vue&type=template&id=19b559bb&scoped=true"
import script from "./TwoPhaseMailVerify.vue?vue&type=script&lang=js"
export * from "./TwoPhaseMailVerify.vue?vue&type=script&lang=js"
import style0 from "./TwoPhaseMailVerify.vue?vue&type=style&index=0&id=19b559bb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19b559bb",
  null
  
)

export default component.exports